import { API_CURRENT_PRODUCT_PROGRAM, API_LOCK_EXTENSION_COST } from 'config'
import Api from 'services/api'

export const getCurrentProductTypesPrograms = () => {
  return Api.get(API_CURRENT_PRODUCT_PROGRAM)
}

export const getLockExtensionCost = () => {
  return Api.get(API_LOCK_EXTENSION_COST)
}
